/* Native links and GET forms remain usable without JavaScript. */
(() => {
  const initialize = (root) => {
    if (root.dataset.flavorInitialized) return;
    root.dataset.flavorInitialized = 'true';
    if (document.body.classList.contains('terplax-flavor-under-nav')) {
      let header;
      let announcement;
      const syncHeroOffsets = () => {
        const headerHeight = header?.getBoundingClientRect().height;
        if (headerHeight > 0) document.body.style.setProperty('--flavor-nav-height', `${headerHeight}px`);
        document.body.style.setProperty('--flavor-topbar-height', `${announcement?.getBoundingClientRect().height || 0}px`);
      };
      const observer = 'ResizeObserver' in window ? new ResizeObserver(syncHeroOffsets) : null;
      const bindHeroOffsets = () => {
        observer?.disconnect();
        header = document.querySelector('.section-header');
        announcement = document.querySelector('.announcement-bar')?.closest('.shopify-section');
        syncHeroOffsets();
        if (header) observer?.observe(header);
        if (announcement) observer?.observe(announcement);
      };
      const unloadHeroOffsets = (event) => {
        if (!event.target.contains(root)) return;
        observer?.disconnect();
        window.removeEventListener('resize', syncHeroOffsets);
        document.removeEventListener('shopify:section:load', bindHeroOffsets);
        document.removeEventListener('shopify:section:unload', unloadHeroOffsets);
      };
      bindHeroOffsets();
      if (!observer) window.addEventListener('resize', syncHeroOffsets, { passive: true });
      document.addEventListener('shopify:section:load', bindHeroOffsets);
      document.addEventListener('shopify:section:unload', unloadHeroOffsets);
    }
    const form = root.querySelector('[data-flavor-form]');
    const sort = root.querySelector('[data-flavor-sort]');
    if (form && sort && typeof form.requestSubmit === 'function') {
      sort.addEventListener('change', () => form.requestSubmit());
      root.classList.add('tplx-flavor--enhanced');
    }
    const categories = root.querySelector('[data-flavor-categories]');
    if (categories) {
      const mobile = window.matchMedia('(max-width: 989px)');
      let mobileExpanded = false;
      const syncCategories = () => { categories.open = !mobile.matches || mobileExpanded; };
      categories.addEventListener('toggle', () => {
        if (mobile.matches) mobileExpanded = categories.open;
      });
      mobile.addEventListener('change', syncCategories);
      syncCategories();
    }
    root.querySelectorAll('[data-flavor-hover]').forEach((link) => {
      const image = link.querySelector('.tplx-flavor__white');
      const scene = link.querySelector('.tplx-flavor__scene');
      if (!image) return;
      if (scene) {
        const sceneFailed = () => link.setAttribute('data-scene-failed', '');
        if (scene.complete && scene.naturalWidth === 0) sceneFailed();
        else scene.addEventListener('error', sceneFailed, { once: true });
      }
      const ready = () => {
        if (image.naturalWidth > 0) link.setAttribute('data-white-ready', '');
      };
      if (image.complete) ready();
      else image.addEventListener('load', ready, { once: true });
      image.addEventListener('error', () => link.removeAttribute('data-white-ready'), { once: true });
    });
  };
  document.querySelectorAll('[data-flavor-collection]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-flavor-collection]').forEach(initialize);
  });
})();
